import axios from 'axios'
import { Address, L1ChainId, L2ChainId } from 'types'
import { ZKLINK_STATIC_ENDPOINT } from '../../config'

export async function getStaticMulticallContracts<
  T extends {
    multicall: Record<L1ChainId, Address>
    faucet: Record<L1ChainId, Address>
  }
>(): Promise<T> {
  return await axios
    .get('/contracts/main.json', {
      baseURL: ZKLINK_STATIC_ENDPOINT,
    })
    .then((r) => r.data)
}

export interface NetworkInfo {
  name: string
  chainId: L1ChainId
  layerTwoChainId: L2ChainId
  symbol: string
  decimals: number
  rpcUrl: string
  explorerUrl: string
  iconUrl: string
}

export async function getStaticNetworksProfile<
  T extends NetworkInfo[]
>(): Promise<T> {
  return await axios
    .get('/networks/list.json', {
      baseURL: ZKLINK_STATIC_ENDPOINT,
    })
    .then((r) => r.data)
}
